<template>
    <div class="dialogue">
        <div class="left">
            <img src="./../assets/image/dialogue/teacher.gif" alt="" class="figure" v-show="speaking">
            <img src="./../assets/image/dialogue/teacher.png" alt="" class="figure" v-show="!speaking">
            <div class="ask">
                <div class="talk-wrap">
                    <div class="img-wrap" v-if="img">
                        <el-image
                                style="width: 360px;"
                                :src="img.url"
                                :preview-src-list="img.srcList">
                        </el-image>
                    </div>
                    <div class="speak-wrap">
                        {{teacherSpeak}}
                    </div>
                </div>
                <div class="options animate__bounceIn" v-if="showOption">
                    <span :class="{active:item===talkList[talkIndex].answer}"
                          v-for="(item,index) in talkList[talkIndex].options" class="option"
                          @click="select(item,index)">
                        {{item}}
                    </span>
                </div>
                <div class="answer-area animate__bounceIn" v-if="showOption">
                    <div class="sort-wrap" v-if="talkList[talkIndex].questionType === 'ranking'">
                        <span>
                            答题区：<span style="color: #9e9e9e" v-if="!talkList[talkIndex].answer.length>0">{{talkList[talkIndex].placeholder}}</span>
                        </span>
                        <span v-for="(item,index) in talkList[talkIndex].answer" :key="index">
                            {{item}}
                            <i class="iconfont icon-arrow-right-copy"
                               v-if="index !== talkList[talkIndex].answer.length-1"></i>
                        </span>
                        <div class="btn-wrap" v-if="!toNextQuestion">
                            <span class="answer" v-if="talkList[talkIndex].answer.length>0" @click="ranking">回答</span>
                            <span class="reset" v-if="talkList[talkIndex].answer.length>0"
                                  @click="()=>{
                                   this.talkList[this.talkIndex].answer = [];
                                   this.showAnswer=false;
                                   this.teacherRightAnswer=''
                                  }">重置</span>
                        </div>
                    </div>
                    <div class="multiple-wrap" v-if="talkList[talkIndex].questionType === 'multiple'">
                        <span>
                            答题区：<span style="color: #9e9e9e" v-if="!talkList[talkIndex].answer.length>0">点击上方选项选择正确的答案</span>
                        </span>
                        <span v-for="(item,index) in talkList[talkIndex].answer" :key="index">
                            {{item}}
                        </span>
                        <div class="btn-wrap" v-if="!toNextQuestion">
                            <span class="answer" v-if="talkList[talkIndex].answer.length>0" @click="multiple">回答</span>
                            <span class="reset" v-if="talkList[talkIndex].answer.length>0"
                                  @click="()=>{
                                   this.talkList[this.talkIndex].answer = [];
                                   this.showAnswer=false;
                                   this.teacherRightAnswer=''
                                  }">重置</span>
                        </div>
                    </div>
                    <i class="iconfont" :class="judge" v-if="showAnswer"></i>
                </div>
                <div class="answer">
                    {{teacherRightAnswer}}
                </div>
                <div class="next" v-if="toNextQuestion && talkIndex !== (talkList.length-1)" @click="nextQuestion">
                    下一题
                </div>
                <div class="next" v-if="toNextQuestion && talkIndex === (talkList.length-1)"
                     @click="nextRoute?$router.push(nextRoute):$emit('close')">
                    下一步
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "dialogue",
        props: {
            img: [Object],
            talkListInit: [Array],
            nextRoute: [String]
        },
        data() {
            return {
                talkIndex: 0,
                teacherSpeak: '',
                teacherRightAnswer: '',
                speaking: true,
                showOption: false,
                showAnswer: false,
                toNextQuestion: false,
                talkList: []
            }
        },
        created() {
            this.talkList = JSON.parse(JSON.stringify(this.talkListInit))
            this.speak(this.talkList[this.talkIndex].txt, 'teacherSpeak').then(() => {
                this.speaking = false;
                this.showOption = true;
            })
        },
        computed: {
            judge() {
                let type = this.talkList[this.talkIndex].questionType;
                switch (type) {
                    case "ranking":
                        for (let i = 0; i < this.talkList[this.talkIndex].answer.length; i++) {
                            if (this.talkList[this.talkIndex].answer[i] !== this.talkList[this.talkIndex].value[i]) {
                                this.scoreEvent(0)
                                return 'icon-wrong';
                            }
                        }
                        this.scoreEvent(this.talkList[this.talkIndex].score)
                        return 'icon-zhengque'
                        break;
                    case 'multiple':
                        let value = this.talkList[this.talkIndex].value;
                        let answer = this.talkList[this.talkIndex].answer;
                        let arr =
                            value.filter(function (v) {
                                return !(answer.indexOf(v) > -1)
                            }).concat(answer.filter(function (v) {
                                return !(value.indexOf(v) > -1)
                            }))
                        if (arr.length > 0) {
                            this.scoreEvent(0)
                            return 'icon-wrong'
                            break;
                        } else {
                            this.scoreEvent(this.talkList[this.talkIndex].score)
                            return 'icon-zhengque'
                            break;
                        }

                    case "choice":
                        if (this.talkList[this.talkIndex].value == this.talkList[this.talkIndex].answer) {
                            this.scoreEvent(this.talkList[this.talkIndex].score)
                            return 'icon-zhengque'

                        } else {
                            this.scoreEvent(0)
                            return 'icon-wrong'
                        }

                        break;
                }
            },
        },
        methods: {
            scoreEvent(num) {
                if (this.$store.state.score[this.talkList[this.talkIndex].questionIndex] === undefined) {
                    let origin = JSON.parse(JSON.stringify(this.$store.state.score))
                    origin[this.talkList[this.talkIndex].questionIndex] = num
                    this.$store.commit('setState', {dataKey: 'score', value: origin})
                }

            },
            speak(str, who, fn) {
                return new Promise((resolve, reject) => {
                    this[who] = "";
                    let that = this;
                    let setTime = null;
                    let time = 70 * (str.length - 1);
                    for (let i = 0; i < str.length; i++) {
                        (function (i) {
                            setTime = setTimeout(() => {
                                that[who] += str[i]
                            }, i * 70)
                        })(i)
                    }
                    setTimeout(() => {
                        resolve()
                    }, time)
                })
            },
            ranking() {
                if (this.talkList[this.talkIndex].answer.length > 0) {
                    this.showAnswer = true;
                    this.speak(this.talkList[this.talkIndex].rightAnswers, 'teacherRightAnswer').then(() => {
                        this.speaking = false;
                        this.toNextQuestion = true
                    })
                }
            },
            multiple() {
                this.showAnswer = true;
                this.speak(this.talkList[this.talkIndex].rightAnswers, 'teacherRightAnswer').then(() => {
                    this.speaking = false;
                    this.toNextQuestion = true
                })
            },
            select(item, index) {
                let type = this.talkList[this.talkIndex].questionType;
                switch (type) {
                    case 'ranking':
                        if (!this.talkList[this.talkIndex].answer.includes(item)) {
                            this.talkList[this.talkIndex].answer.push(item)
                        }
                        break;
                    case 'multiple':
                        if (!this.talkList[this.talkIndex].answer.includes(item)) {
                            this.talkList[this.talkIndex].answer.push(item)
                        }
                        break;
                    case 'choice':
                        this.showAnswer = true;
                        this.speaking = true;
                        this.talkList[this.talkIndex].answer = item
                        this.speak(this.talkList[this.talkIndex].rightAnswers, 'teacherRightAnswer').then(() => {
                            this.speaking = false;
                            this.toNextQuestion = true
                        })
                        break;
                }
            },
            nextQuestion() {
                this.teacherSpeak = '';
                this.teacherRightAnswer = '';
                this.speaking = true;
                this.showAnswer = false;
                this.showOption = false;
                this.toNextQuestion = false;
                this.talkIndex++;
                this.speak(this.talkList[this.talkIndex].txt, 'teacherSpeak').then(() => {
                    this.speaking = false;
                    this.showOption = true;
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .dialogue {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(255, 255, 255, 0.8);
        display: flex;
        line-height: 32px;

        .left {
            width: 100%;

            img.figure {
                position: absolute;
                bottom: 0;
                left: 0;
            }

            .ask {
                display: flex;
                align-items: flex-start;
                justify-content: center;
                flex-direction: column;
                background: #b1ddff;
                font-size: 18px;
                font-weight: bolder;
                position: absolute;
                left: 500px;
                top: 60px;
                border: 66px solid transparent;
                border-radius: 100px;
                min-width: 800px;
                width: 1000px;
                max-width: 1200px;
                min-height: 400px;

                div.talk-wrap {
                    display: flex;
                    align-items: center;
                    margin-bottom: 20px;

                    div.img-wrap {
                        margin-right: 20px;
                    }

                    div.speak-wrap {
                        text-align: left;
                    }
                }

                div.options {
                    display: flex;
                    flex-wrap: wrap;
                    padding-left: 58px;
                    padding-right: 58px;
                    margin-bottom: 20px;
                    position: relative;

                    span.option {
                        font-size: 18px;
                        font-weight: bolder;
                        color: #9e9e9e;
                        margin: 0 10px;
                        cursor: pointer;

                        &:hover {
                            opacity: 0.8;
                        }

                        &.active {
                            color: red;
                        }
                    }
                }

                div.answer-area {
                    width: 100%;
                    padding-left: 58px;
                    padding-right: 58px;
                    position: relative;
                    .sort-wrap, .multiple-wrap {
                        width: 100%;
                        display: flex;
                        justify-content: flex-start;
                        flex-wrap: wrap;
                        background: #FFFFFF;
                        padding: 16px 0;

                        > span {
                            margin: 0 10px;
                        }

                        .btn-wrap {
                            margin-left: 10px;
                            span {
                                cursor: pointer;
                                background: rgba(255, 0, 0, 0.4);
                                color: #FFFFFF;
                                font-size: 14px;
                                font-weight: normal;
                                padding: 6px 10px;
                                transition: background-color 0.3s linear;

                                &:hover {
                                    transition: background-color 0.3s linear;
                                    background: rgba(255, 0, 0, 1);
                                }
                            }

                            span.answer {
                                border-radius: 10px 0 0 10px;
                            }

                            span.reset {
                                border-radius: 0 10px 10px 0;
                            }
                        }
                    }
                    > i {
                        position: absolute;
                        right: -10px;
                        bottom: 16px;
                        margin-left: 20px;
                        font-size: 40px;

                        &.icon-wrong {
                            color: red;
                        }

                        &.icon-zhengque {
                            color: #42b983;
                        }
                    }
                }

                div.answer {
                    margin-top: 20px;
                    text-align: left;
                    word-break: break-all;
                    padding-left: 58px;
                }

                .next {
                    margin-top: 20px;
                    padding: 10px 20px;
                    background: #FF5722;
                    border-radius: 50px;
                    cursor: pointer;
                    position: absolute;
                    bottom: -40px;
                    right: -30px;
                    color: #FFFFFF;
                }
            }
        }

    }
</style>


<style>
    .el-image-viewer__close{
        color: white;
        border-radius: 50%;
        box-shadow: 0 0 50px;
        top: calc(50% - 300px);
        right: calc(50% - 400px);
    }
</style>